import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ChangePasswordForm as formProvider } from 'app/components/modal/dialog-change-password/change-password.form';
import { PatternFormat } from 'app/model/constant';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { DialogGeneralMessageComponent } from '../dialog-general-message/dialog-general-message.component';
import { UserService } from 'app/services/user/user.service';


@Component({
  selector: 'act-dialog-change-password',
  templateUrl: './dialog-change-password.component.html',
  styleUrls: ['./dialog-change-password.component.scss'],
  providers: [formProvider]
})
export class DialogChangePasswordComponent implements OnInit {
  @ViewChild('password') elePassword: ElementRef;
  @ViewChild('confirmPassword') eleConfirmPassword: ElementRef;

  constructor(
    public dialog: MdDialog,
    public dialogRef: MdDialogRef<DialogChangePasswordComponent>,
    private formProvider: formProvider,
    private formBuilder: FormBuilder,
    private translatePipe: TranslatePipe,
    private userService: UserService
  ) { }

  form: FormGroup;
  isLoading: Boolean = false;
  formErrors;

  buildForm() {
    const { getInitForm, matchingPasswords, formErrors } = this.formProvider;
    this.formErrors = formErrors;

    this.form = this.formBuilder.group(getInitForm('', ''), {
      validator: matchingPasswords('newPassword', 'confirmNewPassword')
    });

    this.form.valueChanges.subscribe((data) => {
      this.formProvider.clearErrorMessage(data);
    });
  }


  ngOnInit() {
    this.buildForm();
  }

  setLoadingState(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  isInvalid(field) {
    return this.form.get(field).invalid && this.form.get(field).touched;
  }

  onSubmit() {
    this.setLoadingState(true);

    if (this.form.invalid) {
      this.setLoadingState(false);
      this.formProvider.setErrorMessage(this.form);
      return;
    }

    const { confirmNewPassword, newPassword } = this.form.getRawValue();
    this.userService.changePassword(
      newPassword,
      confirmNewPassword
    ).subscribe((data) => {
      this.dialogRef.afterClosed().take(1).subscribe(() => {
        this.handleOpenDialog({ type: 'SUCCESS' });
      })
      this.dialogRef.close()
    }, (errRes) => {
      const data = errRes.json();
      if (data && data.errors && data.errors.length > 0 && data.errors[0].code === '4214') {
        this.form.get('newPassword').setErrors({ previouslyUsed: true });
        this.formProvider.setErrorMessage(this.form);
        this.setLoadingState(false);
      } else {
        this.dialogRef.afterClosed().take(1).subscribe(() => {
          this.handleOpenDialog({ type: 'FAILURE' });
        })
        this.dialogRef.close()
      }
    });
  }

  handleOpenDialog({ type }) {
    const message = { ...this.createMessage({ type }) };

    const config = {
      hasBackdrop: true,
      disableClose: false,
      focusOnOpen: false,
      data: message
    };

    const dialogRef = this.dialog.open(DialogGeneralMessageComponent, config);
    dialogRef.componentInstance.autoClose = 10
  };

  createMessage({ type }) {
    if (type === 'SUCCESS') {
      return {
        icon: 'icon-successful',
        title: this.translate('my-profile-change-password-success-title'),
        message: this.translate('my-profile-change-password-success-description'),
        mainBtn: this.translate('btn-ok')
      };
    } else {
      return {
        icon: 'icon-service-failed',
        title: this.translate('my-profile-change-password-failure-title'),
        message: this.translate('my-profile-change-password-failure-description'),
        mainBtn: this.translate('btn-ok')
      };
    }
  }

  translate(value) {
    return this.translatePipe.transform(value);
  }

  handleFormReset() {
    this.buildForm();
    this.elePassword.nativeElement.blur();
    this.eleConfirmPassword.nativeElement.blur();
    this.formProvider.clearAllErrorMessage();
  }

  handleCancel() {
    this.dialogRef.close();
  }

  get passwordHasValidLength() {
    const pwc = this.form.controls.newPassword;
    const validCharacter = this.form.controls.newPassword.value.match(PatternFormat.VALID_CHARACTER);
    return pwc.value && !pwc.hasError('minlength') && !pwc.hasError('maxlength') && validCharacter;
  }

  get passwordHasUppercase() {
    return this.form.controls.newPassword.value.match(PatternFormat.AT_LEAST_ONE_UPPERCASE);
  }

  get passwordHasLowercase() {
    return this.form.controls.newPassword.value.match(PatternFormat.AT_LEAST_ONE_LOWERCASE);
  }

  get passwordHasNumeric() {
    return this.form.controls.newPassword.value.match(PatternFormat.AT_LEAST_ONE_NUMERIC);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-change-password/dialog-change-password.component.ts